/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statistics_SubtitleInputs */

const he_statistics_subtitle = /** @type {(inputs: Statistics_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`45 ימים אחרונים`)
};

const en_statistics_subtitle = /** @type {(inputs: Statistics_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last 45 days`)
};

/**
* | output |
* | --- |
* | "Last 45 days" |
*
* @param {Statistics_SubtitleInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const statistics_subtitle = /** @type {((inputs?: Statistics_SubtitleInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statistics_SubtitleInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_statistics_subtitle(inputs)
	return en_statistics_subtitle(inputs)
});